import { InjectionToken } from '@angular/core';

export const CART_TYPE = new InjectionToken<string>('The shopping cart type', {
  providedIn: 'root',
  factory: () => 'IDEALLINK',
});
